export default function (vue) {
	const store = vue.observable({
		isCurrentStepValid: true,
		wizardState: {
			houseType: null,
			immobileClassification: null,
			houseConstruction: null,
			houseSize: null,
			isHouseSizeValid: false,
			propertySize: null,
			isPropertySizeValid: false,
			constructionYear: null,
			isConstructionYearValid: false,
			marjorRenovation: null,
			isMarjorRenovationValid: false,
			appraisalValue: 750000,
			isHouseValueEditable: false,
			existEncumbrances: false,
			isAppraisalValueValid: false,
			initialPayout: null,
			isInitialPayoutValid: false,
			garageSpace: null,
			isGarageSpaceValid: false,
			houseFoundation: null,
			isHouseFoundationValid: false,
			years: null,
			isYearsValid: false,
			desiredRent: null,
			isDesiredRentValid: false,
			investmentAmount: null,
			salutation: null,
			name: null,
			address: null,
			zipCode: null,
			state: null,
			phone: null,
			email: null,
			moreInfo: null,
			requestOffer: null,
			digitalNotification: false,
			pdfNotification: false,
		},
	});
	vue.prototype.$store = store;
}
